import { render, staticRenderFns } from "./CodTour.vue?vue&type=template&id=6cfbac14&"
import script from "./CodTour.vue?vue&type=script&lang=js&"
export * from "./CodTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports